export enum CalendarEventInteraction {
    KeyDown,
    RightClick,
    DoubleClick,
    Click,
}
